/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Form = styled.form`
  all: unset;
  display: flex;
  flex-direction: column;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Field = styled.div`
  width: 100%;
  p {
    color: ${Palette.PrimaryGray._700};
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
  }
`;

export const Content = styled.div`
  background: #fff;
  width: 100%;
  height: 438px;
  padding: 24px;
`;

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 8px;
`;

export const Uploader = styled.span`
  color: ${Palette.Primary._500};
  cursor: pointer;
`;
